export default {
  name: "View",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M31.1 14.33C29.22 11.82 23.98 6 16 6 8.02 6 2.78 11.82.9 14.33a2.64 2.64 0 0 0 0 3.2c1.88 2.5 7.12 8.33 15.1 8.33 7.98 0 13.22-5.82 15.1-8.33.72-.96.72-2.25 0-3.2zm-1.6 1.99c-1.7 2.26-6.42 7.53-13.5 7.53S4.2 18.59 2.5 16.32a.66.66 0 0 1 0-.8C4.2 13.27 8.92 8 16 8s11.8 5.26 13.51 7.53c.18.24.18.55-.01.79zM16 10.85a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
  },
}
